import {
  Building_Sanction_Circular_2013_14_List,
  BuildingCircularSiteMenuList,
} from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Building_Sanction_Circular_2013_14 = () => (
  <TableStructure
    list={Building_Sanction_Circular_2013_14_List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2013-14"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2013_14;
